<template>
    <Teleport to="body">
    <div v-if="isOpen" class="modal sp-modal-card is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Contact Support</p>
                <div class="buttons">
                    <button class="button is-small" aria-label="close" @click="close">
                        <span class="icon is-small">
                            <FontAwesomeIcon :icon="faXmark" />
                        </span>
                    </button>
                </div>
            </header>
            <section class="modal-card-body">
                <div v-if="errors.length" class="notification is-danger is-light mb-4">
                    <ul class="ml-4">
                        <li v-for="error in errors" :key="error">{{ error }}</li>
                    </ul>
                </div>

                <div class="field">
                    <label class="label">Reply-to email</label>
                    <div class="control">
                        <input 
                            v-model="email" 
                            class="input" 
                            type="email" 
                            placeholder="your@email.com"
                            :disabled="isSubmitting"
                        >
                    </div>
                    <p class="help">We'll reply to this address</p>
                </div>

                <div class="field">
                    <label class="label">Message</label>
                    <div class="control">
                        <textarea 
                            v-model="message" 
                            class="textarea" 
                            placeholder="How can we help?"
                            rows="5"
                            :disabled="isSubmitting"
                        ></textarea>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <div class="buttons">
                    <button 
                        class="button is-primary" 
                        @click="submit"
                        :class="{ 'is-loading': isSubmitting }"
                        :disabled="isSubmitting"
                    >
                        Send Message
                    </button>
                    <button 
                        class="button" 
                        @click="close"
                        :disabled="isSubmitting"
                    >
                        Cancel
                    </button>
                </div>
            </footer>
        </div>
    </div>
    </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue';
import axios from 'axios';
import { useBlocksStore } from '../stores/blocks';
import { toastService } from '../utils/toastService';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['close']);

const store = useBlocksStore();

const email = ref('');
const message = ref('');
const errors = ref([]);
const isSubmitting = ref(false);

watch(() => props.isOpen, (newVal) => {
    if (newVal) {
        email.value = store.userSession?.userEmail || '';
        message.value = '';
        errors.value = [];
    }
});

const close = () => {
    emit('close');
};

const submit = async () => {
    errors.value = [];
    isSubmitting.value = true;

    try {
        await axios.post('/api/contact', {
            reply_to_email: email.value,
            message: message.value
        });

        toastService.success('Message sent! We\'ll get back to you soon.');
        close();
    } catch (error) {
        if (error.response?.data?.details) {
            errors.value = error.response.data.details;
        }
    } finally {
        isSubmitting.value = false;
    }
};
</script>
